import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

//Import Icons
import FeatherIcon from "feather-icons-react";

const Navdata = () => {
  const history = useNavigate();
  //state data
  const [isDashboard, setIsDashboard] = useState(false);
  const [isSupport, setIsSupport] = useState(false);
  const [isApps, setIsApps] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [isPages, setIsPages] = useState(false);
  const [isBaseUi, setIsBaseUi] = useState(false);
  const [isAdvanceUi, setIsAdvanceUi] = useState(false);
  const [isForms, setIsForms] = useState(false);
  const [isTables, setIsTables] = useState(false);
  const [isCharts, setIsCharts] = useState(false);
  const [isIcons, setIsIcons] = useState(false);
  const [isMaps, setIsMaps] = useState(false);
  const [isMultiLevel, setIsMultiLevel] = useState(false);

  // BN Rathi
  const [isHoldings, setIsHoldings] = useState(false);
  const [isLedgers, setIsLedgers] = useState(false);
  const [isNetPosition, setIsNetPosition] = useState(false);
  const [isOpenPosition, setIsOpenPosition] = useState(false);
  const [isPortfolio, setIsPortfolio] = useState(false);
  const [isTradeConfirmation, setIsTradeConfirmation] = useState(false);
  const [isContractNote, setIsContractNote] = useState(false);
  //Calender
  const [isCalender, setCalender] = useState(false);

  // Apps
  const [isEmail, setEmail] = useState(false);
  const [isSubEmail, setSubEmail] = useState(false);
  const [isEcommerce, setIsEcommerce] = useState(false);
  const [isProjects, setIsProjects] = useState(false);

  const [isCRM, setIsCRM] = useState(false);
  const [isCrypto, setIsCrypto] = useState(false);
  const [isInvoices, setIsInvoices] = useState(false);
  const [isSupportTickets, setIsSupportTickets] = useState(false);
  const [isNFTMarketplace, setIsNFTMarketplace] = useState(false);

  const [isJobs, setIsJobs] = useState(false);
  const [isJobList, setIsJobList] = useState(false);
  const [isCandidateList, setIsCandidateList] = useState(false);

  // Authentication
  const [isSignIn, setIsSignIn] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false);
  const [isPasswordReset, setIsPasswordReset] = useState(false);
  const [isPasswordCreate, setIsPasswordCreate] = useState(false);
  const [isLockScreen, setIsLockScreen] = useState(false);
  const [isLogout, setIsLogout] = useState(false);
  const [isSuccessMessage, setIsSuccessMessage] = useState(false);
  const [isVerification, setIsVerification] = useState(false);
  const [isError, setIsError] = useState(false);

  // Pages
  const [isProfile, setIsProfile] = useState(false);
  const [isLanding, setIsLanding] = useState(false);

  // Charts
  const [isApex, setIsApex] = useState(false);

  // Multi Level
  const [isLevel1, setIsLevel1] = useState(false);
  const [isLevel2, setIsLevel2] = useState(false);

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Support") {
      setIsSupport(false);
    }
    if (iscurrentState !== "Apps") {
      setIsApps(false);
    }
    if (iscurrentState !== "Auth") {
      setIsAuth(false);
    }
    if (iscurrentState !== "Pages") {
      setIsPages(false);
    }
    if (iscurrentState !== "BaseUi") {
      setIsBaseUi(false);
    }
    if (iscurrentState !== "AdvanceUi") {
      setIsAdvanceUi(false);
    }

    if (iscurrentState !== "Forms") {
      setIsForms(false);
    }
    if (iscurrentState !== "Tables") {
      setIsTables(false);
    }
    if (iscurrentState !== "Charts") {
      setIsCharts(false);
    }
    if (iscurrentState !== "Icons") {
      setIsIcons(false);
    }
    if (iscurrentState !== "Maps") {
      setIsMaps(false);
    }
    if (iscurrentState !== "MuliLevel") {
      setIsMultiLevel(false);
    }
    if (iscurrentState === "Widgets") {
      history("/widgets");
      document.body.classList.add("twocolumn-panel");
    }
    if (iscurrentState === "Landing") {
      setIsLanding(false);
    }
  }, [
    history,
    iscurrentState,
    isDashboard,
    isSupport,
    isApps,
    isAuth,
    isPages,
    isBaseUi,
    isAdvanceUi,
    isForms,
    isTables,
    isCharts,
    isIcons,
    isMaps,
    isMultiLevel,
  ]);

  const menuItems = [
    // {
    //   label: "Menu",
    //   isHeader: true,
    // },
    {
      id: "dashboard",
      label: "Dashboard",
      icon: 
      // <FeatherIcon icon="home" className="icon-dual" />,
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.3235 5.82353V0H18V5.82353H10.3235ZM0 9.52941V0H7.67647V9.52941H0ZM10.3235 18V8.47059H18V18H10.3235ZM0 18V12.1765H7.67647V18H0ZM1.58824 7.94118H6.08824V1.58824H1.58824V7.94118ZM11.9118 16.4118H16.4118V10.0588H11.9118V16.4118ZM11.9118 4.23529H16.4118V1.58824H11.9118V4.23529ZM1.58824 16.4118H6.08824V13.7647H1.58824V16.4118Z" fill="#878A99"/>
</svg>,

      link: "/dashboard",
      stateVariables: isDashboard,
    },

    {
      id: "holdings",
      label: "Holdings",
      // icon: <FeatherIcon icon="clipboard" className="icon-dual" />,
      icon: 
      <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.71261 14C1.23403 14 0.828947 13.8367 0.497368 13.51C0.165789 13.1833 0 12.7843 0 12.3128V1.68723C0 1.21574 0.165789 0.816667 0.497368 0.49C0.828947 0.163333 1.23403 0 1.71261 0H6.9139L8.80863 1.86667H16.2874C16.766 1.86667 17.1711 2.03 17.5026 2.35667C17.8342 2.68333 18 3.08241 18 3.5539V12.3128C18 12.7843 17.8342 13.1833 17.5026 13.51C17.1711 13.8367 16.766 14 16.2874 14H1.71261ZM1.71261 12.6H16.2874C16.3725 12.6 16.4424 12.5731 16.497 12.5193C16.5516 12.4654 16.5789 12.3966 16.5789 12.3128V3.5539C16.5789 3.47006 16.5516 3.40122 16.497 3.3474C16.4424 3.29358 16.3725 3.26667 16.2874 3.26667H8.22742L6.33268 1.4H1.71261C1.6275 1.4 1.55763 1.42691 1.503 1.48073C1.44837 1.53456 1.42105 1.60339 1.42105 1.68723V12.3128C1.42105 12.3966 1.44837 12.4654 1.503 12.5193C1.55763 12.5731 1.6275 12.6 1.71261 12.6Z" fill="#878A99"/>
      </svg>
      ,
      link: "/#",
      isChildItem: true,
      click: function (e) {
        e.preventDefault();
        setIsHoldings(!isHoldings);
        updateIconSidebar(e);
      },
      parentId: "holdings",
      stateVariables: isHoldings,
      subItems: [
        {
          id: 1,
          label: "Include MTF",
          link: "/holdings/include-MTF",
          parentId: "holdings",
        },
        {
          id: 2,
          label: "Without MTF",
          link: "/holdings/without-MTF",
          parentId: "holdings",
        },
        {
          id: 3,
          label: "Only MTF",
          link: "/holdings/only-MTF",
          parentId: "holdings",
        },
      ],
    },
    {
      id: "ledgers",
      label: "Ledgers",
      // icon: <FeatherIcon icon="clipboard" className="icon-dual" />,
      icon: 
      // <i className="mdi mdi-file-multiple-outline" />,
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.25 14.4474H12.75V13.0263H5.25V14.4474ZM5.25 10.6579H12.75V9.23684H5.25V10.6579ZM3.30775 18C2.80258 18 2.375 17.8342 2.025 17.5026C1.675 17.1711 1.5 16.766 1.5 16.2874V1.71261C1.5 1.23403 1.675 0.828947 2.025 0.497368C2.375 0.165789 2.80258 0 3.30775 0H11.25L16.5 4.97368V16.2874C16.5 16.766 16.325 17.1711 15.975 17.5026C15.625 17.8342 15.1974 18 14.6923 18H3.30775ZM10.5 5.68421V1.42105H3.30775C3.23075 1.42105 3.16025 1.45145 3.09625 1.51224C3.03208 1.57287 3 1.63966 3 1.71261V16.2874C3 16.3603 3.03208 16.4271 3.09625 16.4878C3.16025 16.5486 3.23075 16.5789 3.30775 16.5789H14.6923C14.7692 16.5789 14.8398 16.5486 14.9038 16.4878C14.9679 16.4271 15 16.3603 15 16.2874V5.68421H10.5Z" fill="#878A99"/>
</svg>,
      link: "/#",
      isChildItem: true,
      click: function (e) {
        e.preventDefault();
        setIsLedgers(!isLedgers);
        updateIconSidebar(e);
      },
      parentId: "ledgers",
      stateVariables: isLedgers,
      subItems: [
        {
          id: 1,
          label: "Financial Ledger",
          link: "/ledgers/financial",
          parentId: "ledgers",
        },
        {
          id: 2,
          label: "Transaction Ledger",
          link: "/ledgers/transaction",
          parentId: "ledgers",
        },
        {
          id: 3,
          label: "Capital Gain Report",
          link: "/ledgers/capital-gain-report",
          parentId: "ledgers",
        },
      ],
    },
    {
      id: "net-positions",
      label: "Net Positions",
      // icon: <FeatherIcon icon="clipboard" className="icon-dual" />,
      icon: <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 17.5V16.0833H8.28947V5.58371C7.86079 5.47226 7.48579 5.26094 7.16447 4.94975C6.84316 4.63856 6.62361 4.25716 6.50582 3.80556H3.3705L6.1579 10.5165C6.13974 11.2249 5.83121 11.8273 5.23232 12.3237C4.63358 12.8202 3.91579 13.0684 3.07895 13.0684C2.24211 13.0684 1.52432 12.8202 0.925579 12.3237C0.326842 11.8273 0.0183158 11.2249 0 10.5165L2.78739 3.80556H0.947368V2.38889H6.50582C6.65282 1.85008 6.95432 1.40061 7.41032 1.04046C7.86647 0.680153 8.39637 0.5 9 0.5C9.60363 0.5 10.1335 0.680153 10.5897 1.04046C11.0457 1.40061 11.3472 1.85008 11.4942 2.38889H17.0526V3.80556H15.2126L18 10.5165C17.9817 11.2249 17.6732 11.8273 17.0744 12.3237C16.4757 12.8202 15.7579 13.0684 14.9211 13.0684C14.0842 13.0684 13.3664 12.8202 12.7677 12.3237C12.1688 11.8273 11.8603 11.2249 11.8421 10.5165L14.6295 3.80556H11.4942C11.3764 4.25716 11.1568 4.63856 10.8355 4.94975C10.5142 5.26094 10.1392 5.47226 9.71053 5.58371V16.0833H18V17.5H0ZM13.081 10.4712H16.7611L14.9211 6.04507L13.081 10.4712ZM1.23892 10.4712H4.91897L3.07895 6.04507L1.23892 10.4712ZM9 4.27778C9.32921 4.27778 9.60884 4.16303 9.83889 3.93353C10.0691 3.70418 10.1842 3.42542 10.1842 3.09722C10.1842 2.76903 10.0691 2.49026 9.83889 2.26092C9.60884 2.03142 9.32921 1.91667 9 1.91667C8.67079 1.91667 8.39116 2.03142 8.16111 2.26092C7.93089 2.49026 7.81579 2.76903 7.81579 3.09722C7.81579 3.42542 7.93089 3.70418 8.16111 3.93353C8.39116 4.16303 8.67079 4.27778 9 4.27778Z" fill="#878A99"/>
      </svg>
      ,
      link: "/#",
      isChildItem: true,
      click: function (e) {
        e.preventDefault();
        setIsNetPosition(!isNetPosition);
        updateIconSidebar(e);
      },
      parentId: "net-positions",
      stateVariables: isNetPosition,
      subItems: [
        {
          id: 1,
          label: "Capital",
          link: "/net-positions/capital",
          parentId: "net-positions",
        },
        {
          id: 2,
          label: "F&O",
          link: "/net-positions/F&O",
          parentId: "net-positions",
        },
        {
          id: 3,
          label: "Commodity",
          link: "/net-positions/commodity",
          parentId: "net-positions",
        },
      ],
    },
    {
      id: "portfolio",
      label: "Portfolio",
      // icon: <FeatherIcon icon="clipboard" className="icon-dual" />,
      icon: <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 18V16.2737L1.54286 14.6988V18H0ZM4.11429 18V12.074L5.65714 10.4991V18H4.11429ZM8.22857 18V10.4991L9.77143 12.1003V18H8.22857ZM12.3429 18V12.1003L13.8857 10.5254V18H12.3429ZM16.4571 18V7.87436L18 6.29949V18H16.4571ZM0 12.1932V9.97419L6.94286 2.88727L11.0571 7.08692L18 0V2.219L11.0571 9.30592L6.94286 5.10626L0 12.1932Z" fill="#878A99"/>
      </svg>
      ,
      link: "/#",
      isChildItem: true,
      click: function (e) {
        e.preventDefault();
        setIsPortfolio(!isPortfolio);
        updateIconSidebar(e);
      },
      parentId: "portfolio",
      stateVariables: isPortfolio,
      subItems: [
        {
          id: 1,
          label: "Equity",
          link: "/portfolio/equity",
          parentId: "portfolio",
        },
        {
          id: 2,
          label: "F&O",
          link: "/portfolio/F&O",
          parentId: "portfolio",
        },
      ],
    },
    {
      id: "trade-confirmation",
      label: "Trade Confirmation",
      // icon: <FeatherIcon icon="clipboard" className="icon-dual" />,
      icon: <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.95 14.1468L12.2538 9.12197L11.1693 8.09455L6.9345 12.1062L4.8155 10.0987L3.74625 11.1114L6.95 14.1468ZM2.30775 18C1.80258 18 1.375 17.8342 1.025 17.5026C0.675 17.1711 0.5 16.766 0.5 16.2874V1.71261C0.5 1.23403 0.675 0.828947 1.025 0.497368C1.375 0.165789 1.80258 0 2.30775 0H10.25L15.5 4.97368V16.2874C15.5 16.766 15.325 17.1711 14.975 17.5026C14.625 17.8342 14.1974 18 13.6923 18H2.30775ZM9.5 5.68421V1.42105H2.30775C2.23075 1.42105 2.16025 1.45145 2.09625 1.51224C2.03208 1.57287 2 1.63966 2 1.71261V16.2874C2 16.3603 2.03208 16.4271 2.09625 16.4878C2.16025 16.5486 2.23075 16.5789 2.30775 16.5789H13.6923C13.7692 16.5789 13.8398 16.5486 13.9038 16.4878C13.9679 16.4271 14 16.3603 14 16.2874V5.68421H9.5Z" fill="#878A99"/>
      </svg>
      ,
      link: "/#",
      isChildItem: true,
      click: function (e) {
        e.preventDefault();
        setIsTradeConfirmation(!isTradeConfirmation);
        updateIconSidebar(e);
      },
      parentId: "trade-confirmation",
      stateVariables: isTradeConfirmation,
      subItems: [
        {
          id: 1,
          label: "Capital",
          link: "/trade-confirmation/capital",
          parentId: "trade-confirmation",
        },
        {
          id: 2,
          label: "F&O",
          link: "/trade-confirmation/F&O",
          parentId: "trade-confirmation",
        },
        {
          id: 3,
          label: "Commodity",
          link: "/trade-confirmation/commodity",
          parentId: "trade-confirmation",
        },
      ],
    },
    {
      id: "open-positions",
      label: "Open Positions",
      // icon: <FeatherIcon icon="clipboard" className="icon-dual" />,
      icon: <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.92889 1.42105V7.2784V7.25092V16.5789V1.42105ZM4.07223 10.6579H7.38059C7.51872 10.3918 7.67383 10.1404 7.84593 9.90355C8.01819 9.66671 8.20752 9.44447 8.41391 9.23684H4.07223V10.6579ZM4.07223 14.4474H6.7083C6.67289 14.2105 6.65519 13.9752 6.65519 13.7413C6.65519 13.5077 6.66987 13.2693 6.69925 13.0263H4.07223V14.4474ZM2.22205 18C1.74083 18 1.33352 17.8342 1.00011 17.5026C0.666704 17.1711 0.5 16.766 0.5 16.2874V1.71261C0.5 1.23403 0.666704 0.828947 1.00011 0.497368C1.33352 0.16579 1.74083 0 2.22205 0H9.78779L14.7889 4.97368V7.50789C14.5544 7.43747 14.3196 7.38316 14.0845 7.34495C13.8493 7.30658 13.6079 7.2844 13.36 7.2784V5.68421H9.07335V1.42105H2.22205C2.1487 1.42105 2.08154 1.45145 2.02058 1.51224C1.95945 1.57287 1.92889 1.63966 1.92889 1.71261V16.2874C1.92889 16.3603 1.95945 16.4271 2.02058 16.4878C2.08154 16.5486 2.1487 16.5789 2.22205 16.5789H7.41726C7.55523 16.851 7.71034 17.1054 7.88261 17.3423C8.05487 17.5791 8.24721 17.7984 8.45964 18H2.22205Z" fill="#878A99"/>
      <path d="M13.2136 17.8359C12.0239 17.8359 11.0121 17.4212 10.1781 16.5917C9.34397 15.7622 8.92689 14.7559 8.92689 13.5729C8.92689 12.3898 9.34397 11.3836 10.1781 10.5542C11.0121 9.72458 12.0239 9.30979 13.2136 9.30979C14.403 9.30979 15.4149 9.72458 16.249 10.5542C17.083 11.3836 17.5 12.3898 17.5 13.5729C17.5 14.7559 17.083 15.7622 16.249 16.5917C15.4149 17.4212 14.403 17.8359 13.2136 17.8359ZM12.206 15.6498L15.4117 13.5547L12.206 11.4596V15.6498Z" fill="#878A99"/>
      </svg>
      ,
      link: "/#",
      isChildItem: true,
      click: function (e) {
        e.preventDefault();
        setIsOpenPosition(!isOpenPosition);
        updateIconSidebar(e);
      },
      parentId: "open-positions",
      stateVariables: isOpenPosition,
      subItems: [
        {
          id: 1,
          label: "Commodity",
          link: "/open-positions/commodity",
          parentId: "open-positions",
        },
        {
          id: 2,
          label: "F&O",
          link: "/open-positions/F&O",
          parentId: "open-positions",
        },
      ],
    },

    {
      id: "annexure",
      label: "Annexure 10DB",
      icon: <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.7895 0H1.68421C0.757895 0 0 0.736364 0 1.63636V13.0909H1.68421V1.63636H11.7895V0ZM10.9474 3.27273H5.05263C4.12632 3.27273 3.37684 4.00909 3.37684 4.90909L3.36842 16.3636C3.36842 17.2636 4.11789 18 5.04421 18H14.3158C15.2421 18 16 17.2636 16 16.3636V8.18182L10.9474 3.27273ZM5.05263 16.3636V4.90909H10.1053V9H14.3158V16.3636H5.05263Z" fill="#878A99"/>
      </svg>
      
      ,
      link: "/annexure",
      stateVariables: isSupport,
    },

    {
      id: "contract-note",
      label: "Contract Note",
      // icon: <FeatherIcon icon="clipboard" className="icon-dual" />,
      icon: <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.39266 5.86634V4.44529H13.5547V5.86634H5.39266ZM5.39266 8.59926V7.17821H13.5547V8.59926H5.39266ZM7.97968 18H2.36842C1.70653 18 1.14632 17.7707 0.687789 17.3122C0.229263 16.8537 0 16.2935 0 15.6316V12.8989H2.84211V0H16.1053V8.01261C15.8623 7.99918 15.6215 8.01403 15.3829 8.05713C15.1442 8.10024 14.9113 8.17161 14.6842 8.27124V1.42105H4.26316V12.8989H9.63758L8.21653 14.3197H1.42105V15.6316C1.42105 15.9 1.51184 16.125 1.69342 16.3066C1.875 16.4882 2.1 16.5789 2.36842 16.5789H7.97968V18ZM10.0568 18V15.4968L15.1998 10.3772C15.3176 10.2594 15.4451 10.1766 15.5823 10.1286C15.7195 10.0807 15.8568 10.0568 15.9942 10.0568C16.141 10.0568 16.2846 10.0847 16.425 10.1404C16.5652 10.1963 16.6912 10.2801 16.803 10.3919L17.6793 11.2772C17.7813 11.3952 17.8603 11.5228 17.9162 11.66C17.9721 11.7972 18 11.9344 18 12.0716C18 12.2088 17.9745 12.3485 17.9235 12.4906C17.8725 12.6327 17.7911 12.7626 17.6793 12.8804L12.56 18H10.0568ZM11.1863 16.8705H12.0863L15.1614 13.7804L14.7261 13.3304L14.2851 12.8861L11.1863 15.9705V16.8705ZM14.7261 13.3304L14.2851 12.8861L15.1614 13.7804L14.7261 13.3304Z" fill="#878A99"/>
      </svg>
      ,
      link: "/#",
      isChildItem: true,
      click: function (e) {
        e.preventDefault();
        setIsContractNote(!isContractNote);
        updateIconSidebar(e);
      },
      parentId: "contract-note",
      stateVariables: isContractNote,
      subItems: [
        {
          id: 1,
          label: "Contract Note",
          link: "/contract-note",
          parentId: "contract-note",
        },
        {
          id: 2,
          label: "Download History",
          link: "/contract-note-downloads",
          parentId: "contract-note",
        },
      ],
    },

    // {
    //   id: "contract-note",
    //   label: "Contract Note",
    //   icon: <i className="mdi mdi-file-multiple-outline" />,
    //   link: "/contract-note",
    //   stateVariables: isSupport,
    // },

    {
      id: "support",
      label: "Support",
      icon: <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.41713 16V14.5882H15.34C15.419 14.5882 15.4873 14.5641 15.5451 14.5158C15.6028 14.4676 15.6316 14.4043 15.6316 14.3259V7.74306C15.6316 5.94384 14.9836 4.42918 13.6876 3.19906C12.3917 1.96894 10.8292 1.35388 9 1.35388C7.17079 1.35388 5.60826 1.96894 4.31242 3.19906C3.01642 4.42918 2.36842 5.94384 2.36842 7.74306V13.2849H1.65789C1.20363 13.2849 0.81379 13.1278 0.488369 12.8136C0.16279 12.4993 0 12.1165 0 11.6652V9.83718C0 9.53192 0.0874737 9.25224 0.262421 8.99812C0.437368 8.74416 0.665684 8.54 0.947368 8.38565L0.991184 7.18376C1.06887 6.15929 1.33666 5.21027 1.79455 4.33671C2.25245 3.46314 2.83966 2.70267 3.55618 2.05529C4.27287 1.40792 5.1 0.903529 6.03758 0.542117C6.97532 0.180705 7.96279 0 9 0C10.0372 0 11.0222 0.180705 11.9551 0.542117C12.8879 0.903529 13.7151 1.40549 14.4365 2.048C15.1579 2.69051 15.7451 3.44855 16.1981 4.32212C16.6511 5.19584 16.9213 6.14486 17.0088 7.16918L17.0526 8.34753C17.3283 8.47663 17.5551 8.66125 17.7331 8.90141C17.911 9.14157 18 9.40941 18 9.70494V11.8064C18 12.1019 17.911 12.3697 17.7331 12.6099C17.5551 12.85 17.3283 13.0347 17.0526 13.1638V14.3259C17.0526 14.7891 16.8853 15.1839 16.5508 15.5104C16.216 15.8368 15.8124 16 15.34 16H8.41713ZM6.34003 9.66518C6.10808 9.66518 5.91039 9.58706 5.74697 9.43082C5.58371 9.27459 5.50208 9.08118 5.50208 8.85059C5.50208 8.62016 5.58371 8.42533 5.74697 8.26612C5.91039 8.10674 6.10808 8.02706 6.34003 8.02706C6.57213 8.02706 6.76982 8.10674 6.93308 8.26612C7.0965 8.42533 7.17821 8.62016 7.17821 8.85059C7.17821 9.08118 7.0965 9.27459 6.93308 9.43082C6.76982 9.58706 6.57213 9.66518 6.34003 9.66518ZM11.66 9.66518C11.4279 9.66518 11.2302 9.58706 11.0669 9.43082C10.9035 9.27459 10.8218 9.08118 10.8218 8.85059C10.8218 8.62016 10.9035 8.42533 11.0669 8.26612C11.2302 8.10674 11.4279 8.02706 11.66 8.02706C11.8919 8.02706 12.0896 8.10674 12.253 8.26612C12.4163 8.42533 12.4979 8.62016 12.4979 8.85059C12.4979 9.08118 12.4163 9.27459 12.253 9.43082C12.0896 9.58706 11.8919 9.66518 11.66 9.66518ZM3.6675 8.18824C3.56913 6.65224 4.05008 5.33788 5.11034 4.24518C6.17061 3.15263 7.48295 2.60635 9.04737 2.60635C10.3615 2.60635 11.5211 3.01028 12.5261 3.81812C13.5313 4.62596 14.1413 5.67176 14.3562 6.95553C13.0104 6.93984 11.767 6.58878 10.6259 5.90235C9.48482 5.21576 8.60882 4.27459 7.99792 3.07882C7.75745 4.24918 7.25345 5.28384 6.48592 6.18282C5.71824 7.0818 4.77876 7.75027 3.6675 8.18824Z" fill="#878A99"/>
      </svg>
      ,
      link: "/support",
      stateVariables: isSupport,
    },
  ];
  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;

// net-positions/capital
